var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-card",
    { staticClass: "box-processo", attrs: { shadow: "hover" } },
    [
      !_vm.processo
        ? _c("h1", { staticClass: "titulo" }, [_vm._v("Distribuir Processo")])
        : _c(
            "div",
            { staticClass: "box-titulo" },
            [
              _c(
                "el-button",
                {
                  staticClass: "botao-voltar",
                  attrs: { type: "primary" },
                  on: { click: _vm.voltar }
                },
                [
                  _c("span", { staticClass: "center" }, [
                    _c("i", { staticClass: "fas fa-chevron-left" })
                  ])
                ]
              ),
              _vm.processo
                ? _c("span", { staticClass: "span-titulo" }, [
                    _vm._v(_vm._s("Processo " + _vm.numProcesso + ":"))
                  ])
                : _vm._e()
            ],
            1
          ),
      !_vm.processo
        ? _c(
            "el-row",
            { staticClass: "caixa-pesquisa", attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { attrs: { span: 8 } },
                [
                  _c("app-label", {
                    attrs: { label: "Digite o N° do Processo:" }
                  }),
                  _c(
                    "el-input",
                    {
                      staticClass: "input-with-select",
                      attrs: { placeholder: "N° do Processo" },
                      model: {
                        value: _vm.numProcesso,
                        callback: function($$v) {
                          _vm.numProcesso = $$v
                        },
                        expression: "numProcesso"
                      }
                    },
                    [
                      _c("el-button", {
                        staticClass: "color-default",
                        attrs: {
                          slot: "append",
                          icon: "el-icon-search",
                          id: "botao-pesquisar"
                        },
                        on: { click: _vm.pesquisar },
                        slot: "append"
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "el-row",
            { staticClass: "caixa-pesquisa", attrs: { gutter: 30 } },
            [
              _c(
                "el-col",
                { staticClass: "col-principal", attrs: { span: 24 } },
                [
                  _c("card-processo", {
                    attrs: {
                      idProcesso: _vm.processo.id,
                      nomeInteressado: _vm.processo.nomeRazaoSocialInteressado,
                      statusProcesso: _vm.processo.status,
                      numeroProcesso: _vm.processo.numeroProcesso,
                      cpfCnpjInteressado: _vm.processo.cpfCnpjInteressado,
                      setorProcesso: _vm.processo.setor,
                      opcoesAcoes: true,
                      numeroProtocolo: _vm.processo.numeroProtocolo,
                      tipoCodigoProcesso: _vm.processo.tipo.codigo,
                      usuario: _vm.processo.usuario
                    }
                  }),
                  _vm.processo &&
                  _vm.processo.status !== "ARQUIVADO" &&
                  _vm.processo.status !== "FINALIZADO"
                    ? _c(
                        "div",
                        [
                          _c("app-label", {
                            attrs: { label: "Motivo da mudança:" }
                          }),
                          _c("app-editor-texto", {
                            ref: "editorTexto",
                            staticClass: "editor-texto",
                            attrs: {
                              disabled:
                                _vm.processo.status === "ARQUIVADO" ||
                                _vm.processo.status === "FINALIZADO",
                              placeholder: "Digite o motivo da mudança"
                            },
                            on: { onTextChange: _vm.onTextChange },
                            model: {
                              value: _vm.mensagem,
                              callback: function($$v) {
                                _vm.mensagem = $$v
                              },
                              expression: "mensagem"
                            }
                          }),
                          _vm.tarefa &&
                          _vm.tarefa.acoes &&
                          _vm.tarefa.acoes.length
                            ? _c("app-radios-tramitacao", {
                                attrs: {
                                  radios: _vm.tarefa.acoes,
                                  isDecisao: false,
                                  radioInicial: _vm.acao,
                                  isModuloMoverProcesso: true
                                },
                                on: { changeRadio: _vm.changeRadio }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _c(
                "el-col",
                { staticClass: "btn-box" },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "btn",
                      attrs: {
                        type: "primary",
                        disabled:
                          (_vm.tarefa &&
                            _vm.tarefa.acoes &&
                            _vm.tarefa.acoes.length === 0) ||
                          _vm.processo.status.toUpperCase() === "ARQUIVADO" ||
                            _vm.processo.status.toUpperCase() === "FINALIZADO"
                      },
                      on: { click: _vm.distribuirProcesso }
                    },
                    [
                      _c("span", { staticClass: "center" }, [
                        _c("b", [_vm._v("Mover  ")]),
                        _c("i", { staticClass: "fas fa-chevron-right" })
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-019cb7ca", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-019cb7ca","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/manutencao/DistribuirProcessos.vue
// module id = null
// module chunks = 